$(document).ready(function() {

    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#product-grid').addClass('product-list').removeClass('product-grid');
        } else if ($(this).hasClass('gridv')) {
            $('#product-grid').addClass('product-grid').removeClass('product-list');
        } 
    });

  
    // Home Tab Product   
    $('.wbfea,.wbtopr,.nprods,.ourprods').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 2
            }
        }
        ]
    });
  	$(".wbfea").show();
    $(".wbtopr").show();
    $(".nprods").show();
    $(".ourprods").show();

    

    // special product 
    $('.wbspeprod').slick({ 
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 1201,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 449,
            settings: {
                slidesToShow: 1 
            }
        }
        ]
    });
  	$(".wbspeprod").show();

    //   recent products 
    $('.recentprods').slick({    
        dots: false,
        arrows: false,
        infinite: false,  
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 449,  
                settings: {
                    slidesToShow: 1    
                }
            }
            ]
    });
    $(".recentprods").show();

    // product category 
    $('.owl-catt').slick({
        dots: false,
        arrows: false,
        infinite: true, 
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 449,  
            settings: {
                slidesToShow: 1    
            }
        }
        ]
    });
    $(".owl-catt").show();


    // Product With Banner
    $('.wbprobnrtop').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
        dots: false,
        fade: true,
        autoplaySpeed: 6000,
        asNavFor: '.wbprobnrbtm'
    });
    $('.wbprobnrbtm').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: false,
        asNavFor: '.wbprobnrtop',
        dots: true,
        autoplaySpeed: 6000,
        arrows: false
    });
    $(".wbprobnrtop").show();
    $(".wbprobnrbtm").show();


    // Testimonial
    $('.testi').slick({
        slidesToShow: 1,
        dots: false,
        margin:10,
        arrows:true,
        focusOnSelect: true,
        autoplay:false,
        autoplaySpeed:1500,
        responsive: [
        {
        breakpoint: 1200,
        settings: {
        slidesToShow: 1,
        infinite: true,
        }
        },
        {
        breakpoint: 992,
        settings: {
        slidesToShow: 1,
        centerPadding: '100px',
        }
        },
        {
        breakpoint: 767,
        settings: {
        slidesToShow: 1,
        centerPadding: '0',
        }
        },
        {
        breakpoint: 576,
        settings: {
        slidesToShow: 1,
        centerPadding: '0',
        }
        },
        {
        breakpoint: 361,
        settings: {
        slidesToShow: 1,
        centerPadding: '0',
        }
        }
]
});
    $(".testi").show();

    

    // Blog
    $('.wbblog').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
  	$(".wbblog").show();

     


    // Logo Slider
    $('.wblogobar').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 7
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3
            }
        }
        ]
    });
  	$(".wblogobar").show();

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $('#scroll').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    //Menu Overlay
    if ($(window).width() >= 992) {
        $('#megamenu li.wbmenul_1.wbmenusub').hover(function() {
            $('body').addClass('menuoverlay');
            $('.header-wrapper').addClass('menuhdoverlay');
        }, function() {
            $('body').removeClass('menuoverlay');
            $('.header-wrapper').removeClass('menuhdoverlay');
        });
    };

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
        $('.wbmegamainhd').on('click', function() {
            var targetMenu = '#' + $(this).data('submenu');
            $(targetMenu).slideToggle(300);
            $(this).toggleClass('active');
            return false;
        });
    };


        // Popup Product
        $('.wbpopup-popducts .popinner').hide();
        var i = 0;
        setIntervalFun();
        var totalTimer = parseInt(3000) + parseInt(2000);
        setInterval( setIntervalFun, totalTimer);
        function setIntervalFun()
        {
            $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
            setTimeout(function(){
                $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
                i++;
                if ($('.wbpopup-popducts .popinner').length <= i) {
                    i = 0;
                }
            },parseInt(7000));
        }
        $(document).on('click', '.wbclosepopup', function(){
            $('.wbpopup-popducts').fadeOut(400).remove();
        });
    
    
        // Box Layout
        $(".wbboxdemo").click(function(){
            $(".wbboxlt").attr("id","wbboxlayout");
        });
        $(".wbwidedemo").click(function(){
            $(".wbboxlt").removeAttr("id");
        }); 

        // Color Customizer
        $("body").on("click", ".wbinnerclr a", function(e){
        e.preventDefault();
        $('.wbinnerclr').find(".active").removeClass("active");
        $(this).parent().addClass("active");
        $('[wbcolorname=""]').remove();
        if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
        });

        // Rtl Mode
        $("body").on("click", ".wbrtlmode a", function(e){ 
        e.preventDefault();
        $('.wbrtlmode').find(".active").removeClass("active");
        $(this).parent().addClass("active");
        $('[wbrtl=""]').remove();
        if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
        });

        // Color Open/Close 
        $('.wbopen-closeclr').click(function() {
            if ($(this).hasClass('wbclrdisable')) {
                $(this).removeClass('wbclrdisable');
                $(this).addClass('wbclrenable');
                $('.wbcolor_box').animate({right: '30px'}, 450);
                $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
                $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
            } else {
                $(this).removeClass('wbclrenable');
                $(this).addClass('wbclrdisable');
                $('.wbcolor_box').animate({right: '-250px'}, 450);
                $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
                $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
            }
        });

        // Product Category 
    if ($(window).width() >= 992) {
        var count_block = $('.product-category .ptabbr1 .tab-menu').length;
         var number_blocks = 5;
        if(count_block < number_blocks){
        return false;
        } else {
            $('.product-category .ptabbr1 .tab-menu').each(function(i,n){
            if(i> number_blocks) {
            $(this).addClass('it_hide_wbtab-1');
        }
        });
            $('.it_hide_wbtab-1').hide();
            $('.product-category .proview_cat').click(function() {
            $(this).toggleClass('active');
            $('.it_hide_wbtab-1').slideToggle();
        });
        };
        }
        $('.owl-procat1').slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 2000,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2
                    }
                }      
            ]
        });
        $(".owl-procat1").show();
    
    

}); // Document Ready Div End

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "";
    $('body').removeClass("wbbodyscroll");
}

